// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";

export const path = "remove-uploaded-claim-files";

export const removeUploadedClaimFilesParamsSchema = z
  .object({
    tempId: z.string(),
  })
  .strict();




export type RemoveUploadedClaimFilesParams = z.infer<
  typeof removeUploadedClaimFilesParamsSchema
>;




// receiver/remove-uploaded-claim-files endpoint
export function removeUploadedClaimFiles(
  params: z.input<typeof removeUploadedClaimFilesParamsSchema>
): Promise<void> {
  return requestHandler(
    "receiver/remove-uploaded-claim-files",
    params,
    undefined,
  );
}

